import {
	IUserTopicLevel,
	UserTopicLevelSchema as OriginalUserTopicLevelSchema,
} from "@app/api/topics/helper-schemas";
import { store } from "index";
import {
	getDefaultStorageSettings,
	getDefaultReducer,
	filterByLoadTime,
	loadFromStorage,
	listenToLocalStorageChange,
} from "m-model-common";
import { getJoiObjectKeys, validateStorage } from "m-model-joi";
import { createModel, RawInstances, createCRUDActionTypes } from "m-model-core";
import { MAX_LOAD_TIME_DIFF, MIN_LOAD_TIME } from "./constants";
import { CourseCommonMetaInfo } from "./meta-info";
import Joi from "@app/utils/joi";

const UserTopicLevelSchema = OriginalUserTopicLevelSchema.keys({
	needsRecalculation: Joi.boolean(),
});

const keyOfId = "_id";
type IdKey = typeof keyOfId;
type DOC = IUserTopicLevel & { needsRecalculation?: boolean };
export type IStateUserTopicLevels = RawInstances<IdKey, DOC>;

// ==============Base Model=================

const dockeys = getJoiObjectKeys<DOC>(UserTopicLevelSchema);
const storage = localStorage;
const actionTypes = createCRUDActionTypes("userTopicLevel");
const storageSettings = getDefaultStorageSettings("userTopicLevels");
const metaInformationName = "userTopicLevelsMetaInformation";

const isLoadedRecentlyEnough = filterByLoadTime(
	MAX_LOAD_TIME_DIFF,
	MIN_LOAD_TIME
);

const Model = createModel<IdKey, DOC>({
	keyOfId,
	getInstances: (() => store.getState().userTopicLevels) as any,
	dispatch: (action => store.dispatch(action)) as any,
	subscribe: (listener => store.subscribe(listener)) as any,
	actionTypes,
	dockeys,
	loadInstancesFromStorage: () =>
		loadFromStorage({
			storage,
			key: storageSettings.itemName,
			validateWholeData: validateStorage(
				"ObjectId",
				UserTopicLevelSchema
			),
			filter: isLoadedRecentlyEnough,
		}),
	indices: [{ fields: ["userId", "courseId"], unique: true }],
});

// ==============Main Model=================

export class UserTopicLevel extends Model {
	static initialize() {
		const info = super.initialize();
		if (info.loadedAll) this.meta.initialize();
		else this.meta.clear();
		return info;
	}

	static meta = new CourseCommonMetaInfo(storage, metaInformationName);
}

// ==============ETC=================

listenToLocalStorageChange(storage, metaInformationName, UserTopicLevel.meta);

export const userTopicLevelsReducer = getDefaultReducer(
	storageSettings,
	() => UserTopicLevel
);
